// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking-card .booking_header_button {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  width: 100%;
  padding: 10px;
  height: 40px;
}
.booking-card .booking_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.booking-card .booking_header .booking_date {
  height: 40px;
  width: 30%;
}
.booking-card .booking_header .booking_title {
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  margin: 20px 0;
}
.booking-card .booking_tabs {
  overflow-y: hidden;
  overflow-x: auto;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f2f5;
  display: flex;
}
.booking-card .booking_tabs button {
  margin-right: 15px;
}
.booking-card .booking_tabs .border_none {
  border: none;
}

.container-fluid {
  min-height: 78vh;
}
.container-fluid .table_main {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 14%;
  margin: 36px 13px 16px 13px;
}
.container-fluid .table_main .empty {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 200%) !important;
}
.container-fluid .table_main .table_container {
  cursor: pointer;
  margin-bottom: 36px;
  display: flex;
  flex-direction: column;
  color: var(--text);
}
.container-fluid .table_main .table_container .table_chair_top {
  display: flex;
  gap: 8.81px;
}
.container-fluid .table_main .table_container .table_chair_top span {
  flex: 1 1;
  height: 16px;
  background: var(--chair_bg);
  border-radius: 10px 10px 0px 0px;
  margin-bottom: 6px;
}
.container-fluid .table_main .table_container .table_chair_bottom {
  display: flex;
  gap: 8.81px;
}
.container-fluid .table_main .table_container .table_chair_bottom span {
  flex: 1 1;
  height: 16px;
  background: var(--chair_bg);
  border-radius: 0px 0px 10px 10px;
  margin-top: 6px;
}
.container-fluid .table_main .table_container .table_card {
  position: relative;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--chair_bg);
  border-radius: 10px;
  font-size: 13px;
}
.container-fluid .table_main .table_container .table_card .table_chair_left {
  position: absolute;
  right: -22px;
  display: flex;
  flex-direction: column;
}
.container-fluid .table_main .table_container .table_card .table_chair_left span {
  transform: rotate(180deg);
  width: 16px;
  height: 25px;
  background: var(--chair_bg);
  border-radius: 10px 0px 0px 10px;
  margin-bottom: 6px;
}
.container-fluid .table_main .table_container .table_card .table_chair_right {
  position: absolute;
  left: -22px;
  display: flex;
  flex-direction: column;
}
.container-fluid .table_main .table_container .table_card .table_chair_right span {
  transform: rotate(180deg);
  width: 16px;
  height: 27px;
  background: var(--chair_bg);
  border-radius: 0px 10px 10px 0px;
  margin-bottom: 6px;
}

.table_booking {
  width: 100%;
}

.booking_footer {
  height: 70px;
  width: 100%;
  background: var(--anchor-wrapper-bg);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.booking_footer .booking_footer_statics {
  display: flex;
  align-items: center;
}
.booking_footer .booking_footer_statics .booking_text {
  margin-right: 28px;
  display: flex;
  gap: 6px;
}
.booking_footer .booking_footer_statics .booking_text .booking_circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
.booking_footer .booking_footer_statics .booking_text p {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.3px;
  color: var(--text);
  padding: 0;
  margin: 0;
}
.booking_footer .booking_footer_statics h3 {
  border-right: 1px solid #000;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.3px;
  color: var(--body);
  padding-right: 14px;
  padding-left: 18px;
  margin: 0 14px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/booking.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACE,YAAA;EACA,UAAA;AADN;AAGI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADN;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;EACA,aAAA;AAHJ;AAII;EACE,kBAAA;AAFN;AAII;EACE,YAAA;AAFN;;AAOA;EACE,gBAAA;AAJF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,2BAAA;AAHJ;AAII;EACE,kBAAA;EACA,SAAA;EACA,2CAAA;AAFN;AAKI;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAHN;AAIM;EACE,aAAA;EACA,WAAA;AAFR;AAGQ;EACE,SAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,kBAAA;AADV;AAIM;EACE,aAAA;EACA,WAAA;AAFR;AAGQ;EACE,SAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,eAAA;AADV;AAKM;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;AAHR;AAIQ;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAFV;AAIU;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,kBAAA;AAFZ;AAKQ;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAHV;AAIU;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,kBAAA;AAFZ;;AAUA;EACE,WAAA;AAPF;;AAUA;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAPF;AASE;EACE,aAAA;EACA,mBAAA;AAPJ;AAQI;EACE,kBAAA;EACA,aAAA;EACA,QAAA;AANN;AAOM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AALR;AAOM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AALR;AAQI;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AANN","sourcesContent":[".booking-card {\n  .booking_header_button {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    width: 100%;\n    padding: 10px;\n    height: 40px;\n  }\n\n  .booking_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .booking_date {\n      height: 40px;\n      width: 30%;\n    }\n    .booking_title {\n      font-weight: 600;\n      font-size: 22px;\n      line-height: 27px;\n      margin: 20px 0;\n    }\n  }\n\n  .booking_tabs {\n    overflow-y: hidden;\n    overflow-x: auto;\n    padding-bottom: 20px;\n    border-bottom: 2px solid #f0f2f5;\n    display: flex;\n    button {\n      margin-right: 15px;\n    }\n    .border_none {\n      border: none;\n    }\n  }\n}\n\n.container-fluid {\n  min-height: 78vh;\n  .table_main {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 14%;\n    margin: 36px 13px 16px 13px;\n    .empty {\n      position: absolute;\n      left: 50%;\n      transform: translate(-50%, 200%) !important;\n    }\n\n    .table_container {\n      cursor: pointer;\n      margin-bottom: 36px;\n      display: flex;\n      flex-direction: column;\n      color: var(--text);\n      .table_chair_top {\n        display: flex;\n        gap: 8.81px;\n        span {\n          flex: 1;\n          height: 16px;\n          background: var(--chair_bg);\n          border-radius: 10px 10px 0px 0px;\n          margin-bottom: 6px;\n        }\n      }\n      .table_chair_bottom {\n        display: flex;\n        gap: 8.81px;\n        span {\n          flex: 1;\n          height: 16px;\n          background: var(--chair_bg);\n          border-radius: 0px 0px 10px 10px;\n          margin-top: 6px;\n        }\n      }\n\n      .table_card {\n        position: relative;\n        height: 68px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: var(--chair_bg);\n        border-radius: 10px;\n        font-size: 13px;\n        .table_chair_left {\n          position: absolute;\n          right: -22px;\n          display: flex;\n          flex-direction: column;\n\n          span {\n            transform: rotate(180deg);\n            width: 16px;\n            height: 25px;\n            background: var(--chair_bg);\n            border-radius: 10px 0px 0px 10px;\n            margin-bottom: 6px;\n          }\n        }\n        .table_chair_right {\n          position: absolute;\n          left: -22px;\n          display: flex;\n          flex-direction: column;\n          span {\n            transform: rotate(180deg);\n            width: 16px;\n            height: 27px;\n            background: var(--chair_bg);\n            border-radius: 0px 10px 10px 0px;\n            margin-bottom: 6px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.table_booking {\n  width: 100%;\n}\n\n.booking_footer {\n  height: 70px;\n  width: 100%;\n  background: var(--anchor-wrapper-bg);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .booking_footer_statics {\n    display: flex;\n    align-items: center;\n    .booking_text {\n      margin-right: 28px;\n      display: flex;\n      gap: 6px;\n      .booking_circle {\n        width: 14px;\n        height: 14px;\n        border-radius: 50%;\n      }\n      p {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        letter-spacing: -0.3px;\n        color: var(--text);\n        padding: 0;\n        margin: 0;\n      }\n    }\n    h3 {\n      border-right: 1px solid #000;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 16px;\n      letter-spacing: -0.3px;\n      color: var(--body);\n      padding-right: 14px;\n      padding-left: 18px;\n      margin: 0 14px 0 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
